// Fires an event on the global LIFE_CYCLE_EVENT_BUS; Voltron's listeners turn it into analytics.
export const triggerAnalyticsCustomEvent = (eventName, payload) => {
  LIFE_CYCLE_EVENT_BUS.trigger(eventName, payload);
};

// Voltron has no listener of its own for this click, so it rides projects.interaction's
// 'share-overlay-button-click' case. That case pushes a "button submission" / "my account
// settings" event and copies `settings` through verbatim, which is the shape analytics wants.
// It only reads `action` and `settings`; `id` is ignored there but kept for a future listener.
const VIEW_ACCOUNT_DASHBOARD_SETTINGS = 'account dashboard: dashboard snapshot: view account dashboard';

export const triggerViewAccountDashboardClick = (componentId) => {
  triggerAnalyticsCustomEvent('projects.interaction', {
    action: 'share-overlay-button-click',
    settings: VIEW_ACCOUNT_DASHBOARD_SETTINGS,
    id: componentId,
  });
};
